module.exports = __webpack_public_path__ + "static/media/logo-comune.196ff3ca.svg";